import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { setA11yContent } from "../NavigationHelper/actions";
import { fetchCustomerHistory } from "./actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { renderDate } from "utils/renderDate";
import { agentSelectedCustomerDownload } from "./actions";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { media } from "utils/style";
import API from "../../../../Services/API";

import CommonHeader from "common-components/Header";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import Button from "common-components/Buttons";
import Alert from "common-components/Alert";
import {
  DisconnectedCustomer,
  PrepaySuspended,
  PostpaidSuspended
} from "./modals";
import { replaceHashValues } from "utils/replaceHashValues";
import { ENDPOINTS } from "utils/endpoints";

import { Button  as AppelButton} from "@vds/buttons";
import { Table, TableHead, TableHeader, TableBody, TableRow, Cell } from "@vds/tables";


class AuthorizedAgentCustomer extends Component {
  state = {
    blockTransactionReason: "",
    pendingItem: {},
    showModal: false,
    isAgentApproved: true,
    agentStatus: "",
    statusText: {},
    customerDisconnected: false,
    updateAgentAssociationSuccess: false,
    customerSuspendedType: ""
  };

  componentDidMount() {
    const statusText = checkNestedObject(this.props.statusText, "statusText", [0], "approved");

    if (statusText) {
      this.setState({ statusText: { ...this.props.statusText.statusText[0] } });
    }

    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, customerHistory } = this.props.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/authorized-agent" },
        { label: customerHistory, path: "/privacy/secure/authorized-agent/customer" }
      ]);
    }
    

    if (checkNestedObject(this.props, "pageContent", "sc_pagetitle")) {
      this.props.setA11yContent("your customer", this.props.pageContent.sc_pagetitle);
    }
    
    const { agentSelectedCustomer } = this.props;
    
    if (agentSelectedCustomer.status) {
      const status = agentSelectedCustomer.status.toLowerCase();
      if (status !== "active" && status !== "approved") {
        if (status === "expired") {
          this.setState({ agentStatus: "expired" });
        }
        this.setState({ isAgentApproved: false });
      }
    }

    const { state } = this.props.location;
    if (state !== "cancelSuccess") {
      this.props.fetchCustomerHistory(agentSelectedCustomer).then(() => {
        if (this.props.accountStatus && this.props.accountStatus.toLowerCase() === "disconnected") {
          const { agentDetailsData } = this.props;

          API({
            method: "POST",
            url: ENDPOINTS.UPDATE_AGENT_ASSOCIATION,
            data: {
              accountId: agentSelectedCustomer.accountId,
              requestId: agentDetailsData && agentDetailsData.length ? agentDetailsData[0].requestId : ""
            }
          }).then(response => {
            if (response && response.data === true) {
              this.setState({ updateAgentAssociationSuccess: true });
            }
          });
          return this.setState({
            showModal: true,
            customerDisconnected: true,
            blockTransactionReason: "disconnected"
          });
        } else if (this.props.accountStatus && this.props.accountStatus.toLowerCase() === "suspended") {
          const { customerRole: amRole } = this.props.agentSelectedCustomer;
          const customerRole = amRole && typeof amRole === "string" ? amRole.toLowerCase() : "";
          return this.setState({
            showModal: true,
            customerSuspendedType: customerRole === "prepay" ? "prepay" : "postpaid",
            blockTransactionReason: customerRole === "prepay" ? "suspended" : ""
          });
        }
      });
    }
  }
  componentDidUpdate(){
    const { history } = this.props;
    const el = document.getElementById('proof_of_residency');
    const { agentSelectedCustomer } = this.props
    if (el) {
      el.addEventListener("click",function () {
          history.push({
            pathname: "/privacy/secure/authorized-agent/customer/submit-proof",
            state: {
              agentSelectedCustomer: agentSelectedCustomer
            }
          });
      });
    }
  
  }

  renderRequestType = type => {
    const { statusText } = this.state;

    if (type === "DOWNLOAD" || type === "DOWNLOAD_AFFIDAVIT") {
      return statusText.download;
    } else if (type === "DELETE") {
      return statusText.deletion;
    } else if (type === "APPEAL") {
      return statusText.appeal;
    } else if (type === "CORRECT") {
      return statusText.correct;
    }
    return type;
  };

  handleDownloadStatusClick = downloadItem => {
    this.props.agentSelectedCustomerDownload(downloadItem);
    this.props.history.push("customer/status");
  };

  checkCustomerHistory = (requestType, status, downloadAvailabilityDeadline) => {
    if (
      (requestType === "DOWNLOAD" || requestType === "DOWNLOAD_AFFIDAVIT") &&
      (status === "COMPLETED" || status === "IN_PROGRESS")
    ) {
      if (status === "COMPLETED") {
        const isBefore = moment().isBefore(moment(downloadAvailabilityDeadline).add(1, "d"));
        const isAfter = moment().isAfter(moment(downloadAvailabilityDeadline).add(1, "d"));
        
        if (isBefore) {
          return "FILE_AVAILABLE";
        } else if (isAfter) {
          return "EXPIRED";
        }
      } else {
        return "IN_PROGRESS";
      }
    } else if (requestType === "DELETE") {
      if (status === "IN_PROGRESS") {
        return "DELETE_IN_PROGRESS";
      }
    }
    else if (requestType === "APPEAL") {
      if (status === "PENDING") {
        return "APPEAL_IN_PROGRESS";
      }
    }
    else if (requestType === "CORRECT") {
      if (status === "IN_PROGRESS") {
        return "CORRECT_IN_PROGRESS";
      }
    }

    return status;
  };

  renderStatusColumn = ({ requestType, status, requestedBy, downloadAvailabilityDeadline, ...rest }) => {
    let statusText = "";

    const transactionStatus = this.checkCustomerHistory(requestType, status, downloadAvailabilityDeadline);
    const transactionState = {
      requestType,
      status,
      downloadAvailabilityDeadline,
      downloadReady: false,
      ...rest
    };

    if (transactionStatus === "FILE_AVAILABLE") {
      statusText = (
        <ButtonLink
        data-testId="fileAvilabel"
          onClick={() =>
            this.handleDownloadStatusClick({
              ...transactionState,
              ...(transactionState.downloadReady = true)
            })
          }
        >
          {this.state.statusText.fileAvailable}
        </ButtonLink>
      );
    } else if (transactionStatus === "IN_PROGRESS") {
      if (requestedBy === "Agent") {
        statusText = (
          <ButtonLink data-testId="agentInprogress" onClick={() => this.handleDownloadStatusClick(transactionState)}>
            {this.state.statusText.inProgress}
          </ButtonLink>
        );
      } else if (requestedBy === "Client") {
        statusText = transactionStatus;
      }
    } else if (transactionStatus === "APPEAL_IN_PROGRESS") {
      statusText = (
        <StyledButton
          role="link"
          data-testId="appealInprogress"
          onClick={() => this.handleAppealPendingClick({ ...transactionState })}
        >
          {this.state.statusText.inProgress}
        </StyledButton>
      );
    }
    else if (transactionStatus === "CORRECT_IN_PROGRESS") {
      statusText = this.state.statusText.inProgress;
    }
    else {
      statusText = transactionStatus;
    }

    return this.transformStatusText(statusText);
  };

  transformStatusText = status => {
    const cleanStr = typeof status === "string" ? status.toUpperCase() : status;
    const { statusText } = this.state;
    switch (cleanStr) {
      case "EXPIRED":
        return statusText.expired;
      case "IN_PROGRESS":
        return statusText.inProgress;
      case "DELETE_IN_PROGRESS":
        return statusText.inProgress;
      case "COMPLETED":
        return statusText.completed;
      case "CANCELLED":
        return statusText.cancelled;
      case "CANCEL_COMPLETE":
        return statusText.cancelled;
      case "PENDING_PROCESS":
        return statusText.pendingProcess;
      case "PARTIALLY_COMPLETED":
        return statusText.partiallyCompleted;
      case "REJECTED":
        return statusText.rejected;
      case "DELETED":
        return statusText.deleted;
      case "DENIED":
        return statusText.denied;
      case "APPEAL_PENDING":
        return statusText.appealPending;
      case "APPEAL_DENIED":
        return statusText.appealDenied;
      case "APPEAL_CANCELLED":
        return statusText.cancelled;
      case "PENDING":
        return statusText.pendingApproval;

      case "NOT APPROVED":
        return statusText.notApproved;
      default:
        return status;
    }
  };


  /* added for APPEAL */
  isEligibleForAppeal = ({ status, appealFlag }) => {
    return (("DENIED" === status || "DENEGADO" === status) && ("Y" === appealFlag));
  }

  renderAppealColumn = (item, mtn) => {
    const submitAppeal = this.props.appeal[0];
    const { buttons } = submitAppeal;
    const { uniqueTxnId, requestType, state } = item;
    return (
      <AppelButton
        size="small"
        disabled={false}
        use="primary"
        data-testId="AppelButton"
        key={uniqueTxnId}
        background={buttons[2].type}
        onClick={() => this.props.history.push({
          pathname: "/privacy/secure/authorized-agent/customer/submit-appeal",
          state: { confirmAuth: true, payload: { uniqueTxnId, requestType, state, mtn } }       
                })
                }
       >
       {buttons[2].text}
      </AppelButton>
    );

  }

  handleAppealPendingClick = item => {

    const { uniqueTxnId } = item;
    const theActualRecordOnWhichTheAppealApplied = this.props.agentCustomerHistory.filter((item) => item.appealId && item.appealId.endsWith(uniqueTxnId) && item.status === "APPEAL_PENDING");


    if (checkNestedObject(this.props, "appeal", [2])) {
      this.props.history.push({
        pathname: "/privacy/secure/authorized-agent/customer/appeal-status",
        state: {
          confirmAuth: true,
          historyInfo: item,
          theActualRecordOnWhichTheAppealApplied
        }
      });
    }

  }
  /* end of added for APPEAL */

  /* added for CORRECT */
  // handleCorrectInProgressClick = item => {
  //   if (checkNestedObject(this.props, "correction_pending")) {
  //     this.props.history.push({
  //       pathname: "/privacy/secure/authorized-agent/customer/correct-status",
  //       state: {
  //         confirmAuth: true,
  //         historyInfo: item
  //       }
  //     });
  //   }
  // }
  /* end of added for CORRECT */

  handleNewRequestClick = () => {
    if (
      !this.state.isAgentApproved || this.state.blockTransactionReason
    ) {
      this.props.history.push("/privacy/secure/authorized-agent");
    } else {
      this.props.history.push("new-request");
    }
  };

  closeModal = () => {
    if (this.state.updateAgentAssociationSuccess) {
      const { agentSelectedCustomer } = this.props;
      const { agentAssociationList } = window.reactGlobals.agentInfo;

      const removedCustomerList = agentAssociationList.filter(
        item => item.accountId !== agentSelectedCustomer.accountId
      );
      window.reactGlobals.agentInfo.agentAssociationList = removedCustomerList;
      this.props.history.replace("/privacy/secure/authorized-agent");
    }
    this.setState({ showModal: false });
  };

  renderModal = () => {
    if (this.state.showModal) {
      if (this.state.customerSuspendedType) {
        if (this.state.customerSuspendedType === "prepay") {
          return (
            <PrepaySuspended
              modalContent={this.props.prepaySuspendedModalContent}
              closeModal={this.closeModal}
            />
          );
        }
        return (
          <PostpaidSuspended
            modalContent={this.props.postpaidSuspendedModalContent}
            closeModal={this.closeModal}
          />
        );
      } else if (this.state.customerDisconnected) {
        return (
          <DisconnectedCustomer
            modalContent={this.props.disconnectedCustomerModal}
            closeModal={this.closeModal}
            goBack={() => this.props.history.goBack()}
          />
        );
      }
    }
    return null;
  };

  renderCustomerIdentifier = ({ serviceType, accountId, mtn }) => {
    if (serviceType && typeof serviceType === "string") {
      const lob = serviceType.toLowerCase();

      if (lob === "vzt" || lob === "ott") {
        return accountId;
      }
    }

    return formatPhoneNumber(mtn);
  };

  renderHeaderContent = () => {
    const { agentStatus, customerDisconnected } = this.state;
    const {
      pageContent,
      expired_agent_page_content,
      disconnected_customer_content,
      agentSelectedCustomer
    } = this.props;

    if (customerDisconnected) {
      return (
        <Fragment>
          <Header data-testid="CustomerDisconnectedHeader">
            {convertStringToElements(disconnected_customer_content[0].section_title)}
          </Header>
          <div style={{ maxWidth: "596px", marginBottom: "18px" }}>
            {convertStringToElements(
              replaceHashValues(disconnected_customer_content[0].section_description, {
                selectedMDN: this.renderCustomerIdentifier(agentSelectedCustomer)
              })
            )}
          </div>
        </Fragment>
      );
    } else if (agentStatus === "expired") {
      return (
        <Fragment>
          <Header>
            {convertStringToElements(expired_agent_page_content[0].section_title)}
          </Header>
          <div style={{ maxWidth: "596px", marginBottom: "18px" }}>
            {convertStringToElements(
              replaceHashValues(expired_agent_page_content[0].section_description, {
                selectedMDN: this.renderCustomerIdentifier(agentSelectedCustomer)
              })
            )}
          </div>
        </Fragment>
      );
    } else {
      return (
        <Header>{convertStringToElements(pageContent[0].section_title)}</Header>
      );
    }
  };

  renderSuspendedBanner = () => {
    if (this.props.suspendedReason) {
      if (
        checkNestedObject(this.props.pageContent, [2], "section_description") &&
        checkNestedObject(this.props.pageContent, [3], "section_description")
      ) {
        const { suspendedReason } = this.props;
        if (suspendedReason === "EMAIL_NOT_EXIST") {
          return (
            <Alert alertType="warning">
              {convertStringToElements(this.props.pageContent[2].section_description)}
            </Alert>
          );
        } else {
          return (
            <Alert alertType="warning">
              {convertStringToElements(this.props.pageContent[3].section_description)}
            </Alert>
          );
        }
      }
    }
    return null;
  };

  render() {
    if (!checkNestedObject(this.props, "pageContent", [0], "genericList")) {
      return <Redirect data-testid="redirect" to="/privacy/secure/authorized-agent" />;
    }

    const { isAgentApproved, blockTransactionReason } = this.state;
    const {
      pageContent,
      agentSelectedCustomer,
      agentCustomerHistory,
      loading,
      disconnected_customer_content
    } = this.props;
    const [
      {
        genericList: [{ list: tableHeaders }]
      },
      { buttons, genericList: noData }
    ] = pageContent;
    
    const history_details = pageContent[1];
    const { appeal_proof } = this.props;
    const privacyInquiryInfo = appeal_proof && appeal_proof[0]["Category"] && appeal_proof[0]["Category"].length > 0 ? appeal_proof[0]["Category"][0].category_description : "";
    
    {/* DPCMP - 156,155,163 Request Number column */}
    if(!window.reactGlobals.requestNumberFFlag) {
      history_details.genericList[0].list = history_details.genericList[0].list = history_details.genericList[0].list.filter(
      item => item.jsonKey !== "requestnumberheading" 
    );
    }

    return (
      <Container>
        {this.renderSuspendedBanner()}
        {this.renderModal()}
        {this.renderHeaderContent()}
        <Tablesdiv>
        <Table
          bottomLine='none'
          padding='compact'
          >
          {/*<Caption>Customer information</Caption>*/}
          <TableBody>
            <TableRow>
              <Cell><b>{tableHeaders[0].jsonValue}</b></Cell>
              <Cell data-qm-encrypt="true">{this.renderCustomerIdentifier(agentSelectedCustomer)}</Cell>
            </TableRow>
            <TableRow>
              <Cell><b>{tableHeaders[1].jsonValue}</b></Cell>
              <Cell>{moment(cleanDateFormat(agentSelectedCustomer.effectiveDate)).format("MMM D, YYYY")}</Cell>
            </TableRow>
            <TableRow>
              <Cell><b>{tableHeaders[2].jsonValue}</b> </Cell>
              <Cell>{renderDate(agentSelectedCustomer.endDate)}</Cell>
             </TableRow>
          </TableBody>
        </Table>
        </Tablesdiv>

        <SubContainer>
          <H2>{convertStringToElements(pageContent[1].section_title)}</H2>
          {loading ? (
            <RectangleLoader style={{ padding: "0" }} />
          ) : (
            <>
            <HistoryTable>
              <Table
              striped={false}
              bottomLine="secondary"
              surface="light"
              padding="standard"              
              >
                {/*<Caption>Customer history</Caption>*/}
                <TableHead bottomLine="secondary">                  
                    {history_details.genericList[0].list.map(item => (
                      <TableHeader key={item.jsonKey}><th>{item.jsonValue}</th></TableHeader>
                    ))}
                </TableHead>
                <TableBody>
                  {agentCustomerHistory.length ? (
                    agentCustomerHistory.map(item => (
                      <TableRow key={item.dateOfRequest}>
                        <Cell>
                          {moment(cleanDateFormat(item.dateOfRequest), "YYYY-MM-DD HH:mm:ss").format(
                            "MMM D, YYYY h:mma"
                          )}
                        </Cell>
                        <Cell>{this.renderRequestType(item.requestType)}</Cell>
                        <Cell>{item.requestedBy ? item.requestedBy : ''}</Cell>
                        <Cell>{this.renderStatusColumn(item)}</Cell>
                        {/* DPCMP - 156,155,163 Request Number column */}
                        {window.reactGlobals.requestNumberFFlag &&  
                              <Cell>{item.requestNumber ? item.requestNumber : ''}</Cell>
                        }
                        {/* added for APPEAL */}
                        {
                          true === this.isEligibleForAppeal(item)
                            ?
                            <Cell>{!this.props.loading && item ? this.renderAppealColumn(item, agentSelectedCustomer.mtn) : ""}</Cell>
                            :
                            ""
                        }
                        {/* end of added for APPEAL */}

                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <Cell colSpan="3">{convertStringToElements(noData[1].list[0].jsonValue)}</Cell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              </HistoryTable>
              <PrivacyInquiry>{convertStringToElements(privacyInquiryInfo)}</PrivacyInquiry>

              {/* {!agentCustomerHistory.length && !loading && (
                <EmptyRow>{convertStringToElements(noData[1].list[0].jsonValue)}</EmptyRow>
              )} */}
              <Button
                style={{ marginTop: `${privacyInquiryInfo !== undefined ? "48px" : "56px"}` }}
                background={buttons[0].type}
                role={blockTransactionReason ? "button" : "link"}
                onClick={this.handleNewRequestClick}
              >
                {isAgentApproved && !blockTransactionReason
                  ? buttons[0].text
                  : disconnected_customer_content[1].buttons[0].text}
              </Button>
            </>
          )}
        </SubContainer>
      </Container>
    );
  }
}
const mapStateToProps = ({
  pageContent: {
    authorized_agent_requesthistory: pageContent,
    download_pending_modal,
    delete_pending,
    authorized_agent_assignment_expired: expired_agent_page_content,
    breadCrumbs,
    statusText,
    agent_landing_page_disconnected_customers: disconnectedCustomerModal,
    agent_assignment_disconnected_customers: disconnected_customer_content,
    customer_with_suspended_postpaid: postpaidSuspendedModalContent,
    customer_with_suspended_prepaid: prepaySuspendedModalContent,
    appeal,
    appeal_proof,
    correction_pending
  },
  loadingAndErrorState: { loading, error },
  agentSelectedCustomer,
  agentCustomerHistory: {
    elementsData: agentCustomerHistory,
    custRequestedBefore: customerPendingRequest,
    accountStatus,
    agentDetailsData,
    suspendedReason
  }
}) => ({
  loading,
  error,
  agentCustomerHistory,
  agentSelectedCustomer,
  pageContent,
  download_pending_modal,
  delete_pending,
  customerPendingRequest,
  expired_agent_page_content,
  breadCrumbs,
  statusText,
  accountStatus,
  disconnectedCustomerModal,
  disconnected_customer_content,
  agentDetailsData,
  suspendedReason,
  postpaidSuspendedModalContent,
  prepaySuspendedModalContent,
  appeal,
  appeal_proof,
  correction_pending
});

export default connect(
  mapStateToProps,
  { setA11yContent, setBreadcrumbList, fetchCustomerHistory, agentSelectedCustomerDownload }
)(AuthorizedAgentCustomer);

const ButtonLink = styled.button.attrs({
  role: "link"
})`
  background: 0;
  border: 0;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;

const StyledButton = styled.button`
  cursor: pointer;
  background: none;
  border: 0;
  font-size: 14px;
  text-decoration: underline;
  padding: 2px;
  margin: 0 -2px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;

  ${media.mobile`
    font-size: 12px;
  `}
`;

const HistoryTable = styled.div`
  width: 100%;
  text-align: left;

  th {
    width: 25%;    
    padding: 25px 0 12px 0;
    font-size:16px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }
`;

const Tablesdiv = styled.div`
  max-width: 386px;
  width: 100%;


  td {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  
    ${media.mobile`
      font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;   
    `}
  }
  
`;

const Caption = styled.caption`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const TH = styled.th`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  padding: 20px 0;

  ${media.mobile`
  font-family: "Verizon-NHG-eTX", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
   font-weight: 700;
`}
  
`;

const H2 = styled.h2`
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 36px;
  // border-bottom: 4px solid;
  padding-bottom: 24px;

  ${media.mobile`
  font-size: 24px;
  `}
`;

const SubContainer = styled.div`
  margin: 38px 0 58px 0;
  max-width: 635px;
`;

const TD = styled.td`
  padding: 24px 0px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  ${media.mobile`
    padding: 20px 0px; 
    font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;   
  `}
`;

const TR = styled.tr`
  border-bottom: 1px solid #d8dada;
`;

const Div = styled.div`
  max-width: 809px;
  overflow: auto;
  ${media.tablet`
    margin: 0 auto;
  `}
`;


const PrivacyInquiry = styled.div`
  font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
  font-size:12px;
  padding-top: 40px;
  max-width:415px;
  
  a,p {
    font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
    font-size: 12px;
  }
  
  #proof_of_residency  {
    text-decoration: underline;
    border: transparent;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.5px;
    font-weight: 700;
  }

  #proof_of_residency:focus, #proof_of_residency.focus {
   outline: none !important;
  }

`;

const Header = styled(CommonHeader)`
  font-size: 48px;
  line-height: 48px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-style: normal;
  max-width: 565px;
  margin-bottom: 48px;

  ${media.mobile`
   font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
   font-size: 32px;
   font-style: normal;
   font-weight: 400;
   line-height: 36px;
   margin-top: 40px;
  `};
`;
